// Maps backend role identifiers to their translatable label keys (resolved in the `bo` namespace).
// Shared by the users table and the parameters page; mirrors the UserForm role options.
export const ROLE_LABELS = {
    ROLE_ADMIN: 'Administrator',
    ROLE_TECH: 'Tech',
    ROLE_CATALOGUE: 'Catalogue',
    ROLE_PRODUCT: 'Product',
    ROLE_CSM: 'CSM',
    ROLE_SALES: 'Sales',
};

// Mirrors security.yaml's role_hierarchy: Admin inherits every BO role, Product inherits Catalogue.
export const ROLE_HIERARCHY = {
    ROLE_ADMIN: ['ROLE_TECH', 'ROLE_PRODUCT', 'ROLE_CSM', 'ROLE_SALES'],
    ROLE_PRODUCT: ['ROLE_CATALOGUE'],
};

// Expands a list of stored roles through the hierarchy above and checks whether the
// resulting set contains the required role.
export const hasRole = (userRoles = [], role) => {
    const expanded = new Set(userRoles);
    let added = true;
    while (added) {
        added = false;
        for (const current of expanded) {
            for (const inherited of ROLE_HIERARCHY[current] ?? []) {
                if (!expanded.has(inherited)) {
                    expanded.add(inherited);
                    added = true;
                }
            }
        }
    }
    return expanded.has(role);
};

// Minimum role required to access each BO page. A page absent from this map is open to all roles.
// Shared by the router (RoleRoute) and the menu (nav item filtering).
export const PAGE_ROLES = {
    collections: 'ROLE_CATALOGUE',
    tags: 'ROLE_CATALOGUE',
    users: 'ROLE_ADMIN',
};
